








import Vue from 'vue';
import { Component, Prop, Model } from 'vue-property-decorator';

@Component
export default class InputCheckbox extends Vue {
	@Prop()
	value!: any;

	@Prop({ type: String, required: false, default: '' })
	label!: string;

	@Prop({ type: String, required: true })
	name!: string;

	@Prop({ type: [String, Object], required: false, default: '' })
	rules!: string | object;

	@Prop({ type: Boolean, required: false, default: true })
	showErrors!: boolean;

	@Model('change', { default: false }) readonly modelValue!: any;

	get id() {
	    return this.name + new Date().valueOf();
	}

	get shouldBeChecked() {
	    if (Array.isArray(this.modelValue)) {
	        return this.modelValue.includes(this.value);
	    }
	    return !!this.modelValue;
	}

	changedInput(event: any) {
	    const isChecked = event.target.checked;

	    if (Array.isArray(this.modelValue)) {
	        const newValue = [...this.modelValue];

	        if (isChecked) {
	            newValue.push(this.value);
	        } else {
	            newValue.splice(newValue.indexOf(this.value), 1);
	        }

	        this.$emit('change', newValue);
	    } else {
	        this.$emit('change', isChecked);
	    }
	}
}
